var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg031Cloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M462,226.646v-13.324C462,138.154,400.846,77,325.678,77c-32.733,0-64.381,11.776-89.115,33.16 c-16.364,14.147-29.026,31.881-37.093,51.591C187.067,155.414,173.217,152,159,152c-49.075,0-89,39.925-89,89v18.187 C29.978,268.162,0,303.68,0,346c0,23.773,8.999,46.067,25.34,62.774C41.881,425.687,64.134,435,88,435h312 c0.513,0,1.021-0.02,1.526-0.058c19.282-0.59,38.173-6.085,54.702-15.92c9.492-5.648,12.608-17.923,6.96-27.415 c-5.648-9.493-17.925-12.606-27.415-6.96c-10.911,6.492-23.422,10.065-36.184,10.332c-0.197,0.004-0.394,0.011-0.589,0.021H88 c-26.916,0-48-21.523-48-49c0-27.019,22.36-49,49.846-49H90c11.046,0,20-8.954,20-20v-36c0-27.019,21.981-49,49-49 c14.035,0,27.427,6.052,36.742,16.604c5.133,5.816,13.167,8.142,20.612,5.959c7.445-2.179,12.958-8.466,14.146-16.132 C237.693,152.008,278.611,117,325.678,117C378.79,117,422,160.21,422,213.322v24.598c0,7.4,4.087,14.196,10.624,17.666 C456.912,268.477,472,293.542,472,321c0,11.046,8.954,20,20,20c11.046,0,20-8.954,20-20C512,282.868,493.119,247.737,462,226.646z "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg031Cloud);
export default __webpack_public_path__ + "static/media/031-cloud.5ce6ce1038fceb910472723836f2f869.svg";
export { ForwardRef as ReactComponent };